import React, { useState, FormEvent } from "react";
import companyLogo from "../assets/company_logo.png";
import footerImage from "../assets/login_footer.png";
import youLikeNoOtherImage from "../assets/youLikeNoOther.png";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

// Define the shape of the user object after a successful login
interface User {
  mobileNumber: string;
  token: string;
}

// Define the props for the LoginPage component
interface LoginPageProps {
  onLoginSuccess: (user: User) => void;
  onLoginFailure: (error: string) => void;
}

const LoginPage: React.FC<LoginPageProps> = ({
  onLoginSuccess,
  onLoginFailure,
}) => {
  const [mobileNumber, setMobileNumber] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [rememberMe, setRememberMe] = useState<boolean>(false);

  // This function will be called when the form is submitted
  const handleSubmit = async (
    event: FormEvent<HTMLFormElement>
  ): Promise<void> => {
    event.preventDefault();

    try {
      const response = await fetch("http://localhost:3001/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ mobileNumber, password }),
      });

      if (!response.ok) {
        throw new Error("Login failed");
      }

      const data = await response.json();
      onLoginSuccess({ mobileNumber: data.mobileNumber, token: data.token });
      Swal.fire({
        title: "Login Successful",
        icon: "success",
        confirmButtonText: "Continue",
        preConfirm: () => window.location.assign("/dashboard"),
      });
    } catch (error) {
      Swal.fire({
        title: "Login Failed",
        icon: "error",
        confirmButtonColor: "red",
        confirmButtonText: "Close",
      });
      onLoginFailure(error instanceof Error ? error.message : String(error));
    }
  };

  return (
    <>
      <img
        src={youLikeNoOtherImage}
        alt="You Like No Other"
        className="absolute left-[200px] md:left-[780px] top-[10px] md:top-[20px]"
        width={120}
      />

      <div className="flex flex-col gap-3 w-full items-center justify-center min-h-screen p-3">
        <div className="w-full md:w-[30%] mt-4 p-3 md:p-8 bg-[#FAFAFA] border border-[#ECECEC] shadow-[0px_4px_56.9px_rgba(0,0,0,0.05)] rounded-[20px] pb-4">
          <div className="flex justify-center">
            <img
              className="mx-auto my-4"
              src={companyLogo}
              alt="Company Logo"
              width={150}
            />
          </div>

          <h1 className="text-center text-2xl font-semibold mb-2">
            Welcome Back
          </h1>
          <p className="text-center text-sm font-normal text-[#3D3D3D] mb-4">
            Enter your email and password to access your account
          </p>

          {/* Form */}
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col gap-3">
              <label
                htmlFor="mobileNumber"
                className="text-base text-[#363636]"
              >
                Mobile Number
              </label>
              <input
                type="text"
                id="mobileNumber"
                name="mobileNumber"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
                placeholder="Enter your number here"
                className="w-full outline-none h-[40px] border border-[#B4B4B4] rounded-[14px] px-4 text-sm text-black"
              />
            </div>

            <div className="flex flex-col gap-3">
              <label htmlFor="password" className="text-base text-[#363636]">
                Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="w-full h-[40px] outline-none border border-[#B4B4B4] rounded-[14px] px-4 text-sm text-black"
              />
            </div>

            {/* Remember Me and Forgot Password */}
            <div className="flex justify-between items-center">
              <label className="flex items-center text-sm text-[#3D3D3D]">
                <input
                  type="checkbox"
                  className="form-checkbox h-4 w-4 text-indigo-600 border-gray-300 rounded mr-2"
                />
                Remember me
              </label>
              <Link
                to={"/password/reset"}
                className="text-sm text-blue-500 hover:text-blue-800"
              >
                Forgot password?{" "}
                <span className="text-sm text-red-600">Reset</span>
              </Link>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full h-14 bg-red-600 hover:bg-red-700 text-white rounded-[14px] mt-3"
            >
              Sign In
            </button>
          </form>
        </div>

        <div className="self-start flex flex-col px-3 md:px-10">
          <img src={footerImage} alt="" className="w-full md:w-[300px]" />
        </div>
      </div>
    </>
  );
};

export default LoginPage;
